

<template>
  <div class="container" :style='{backgroundColor}'>
      <ui-icon class="center" v-if="icon" :icon="icon" background-color="transparent"/> 
    <div class="center">{{$t(title)}}</div>
  </div>
</template>

<script>
// these are the option under a swipeable button. options revealed when swipe to left
import UiIcon from './UiIcon.vue';

export default {
  name: 'ui-option',
  props:{
    title:{ default:"none"},
    icon:{ default:"plus"},
    backgroundColor:{default:"#FF0000"}
  },
  computed:{
  },
  methods:{
  },
  components:{
    UiIcon,
  },
  created(){
  }
  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.container{
  min-width:65px;
  cursor:pointer;
  display:inline-flex;
  padding:0 10px;
  height:100%;
  flex-direction: column;
  color:#FFFFFF;
  justify-content:center;
  border:1px solid rgba(0,0,0,.10);
}
.center{
  text-align:center;
  width:100%;
}

</style>
